var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-icon-list-with-texts"},[_c('div',{staticClass:"row"},_vm._l((_vm.dataList),function(item,i){return _c('div',{key:i,staticClass:"col",class:{
        [`col-${_vm.columnNumber}`]: true,
        [`col-sm-${_vm.tabletColumnNumber}`]: true,
        [`col-xs-${_vm.mobileColumnNumber}`]: true
      }},[_c('AtomsCommonAtomIconAndText',{attrs:{"icon":item.icon,"icon-image":item.iconImage,"title":_vm.$tdb(item.title),"description":_vm.$tdb(item.description),"border-color":item.borderColor}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }